import { useMemo } from 'react';
import CustomFieldDefinitionDto from '@/features/dashboard/tourCustomFields/types/_CustomFieldDefinitionDto.ts';
import { createEmptyParticipant } from '@/features/shared/booking/utils/createEmptyParticipant.ts';

export const useInitParticipantValues = (
  participantForm: CustomFieldDefinitionDto[],
) => {
  const getParticipantInitValues = useMemo(
    () => () => createEmptyParticipant(participantForm),
    [participantForm],
  );

  return {
    getParticipantInitValues,
  };
};
